// The backend sends null when it has no raw event type to report (see
// dashboard.service.ts's `event.sync?.rawEventType ?? null`) - not just for
// the dashboard feed, so this stays defensive rather than pushing a
// non-null assertion onto every caller.
export const formatEventType = (
  eventType: string | null | undefined
): string => {
  if (!eventType) return '';

  return eventType
    .split('_')
    .map((word) => word.charAt(0) + word.slice(1).toLowerCase())
    .join(' ');
};

export const formatResource = (
  resource: string | null | undefined
): string => {
  if (!resource) return '';

  return resource
    .split('_')
    .map((word) => word.charAt(0) + word.slice(1).toLowerCase())
    .join(' ');
};

export const formatEventDate = (dateString: string): string => {
  const date = new Date(dateString);
  const options: Intl.DateTimeFormatOptions = {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  };
  const formattedDate = date.toLocaleDateString('en-GB', options);
  const time = date.toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
  });
  return `${formattedDate}, ${time}`;
};

// Dummy user data generator
export const getDummyUser = (userId: string) => {
  const dummyUsers = [
    { initials: 'AN', name: 'Ann Smith' },
    { initials: 'LD', name: 'Lucas Donov...' },
    { initials: 'SK', name: 'Sophia Keller' },
    { initials: 'UW', name: 'Ulrich Walker' },
  ];

  // Simple hash to consistently map userId to same dummy user
  const hash = userId.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
  return dummyUsers[hash % dummyUsers.length];
};
